import { DatePicker as AntDatePicker } from "antd";
import momentGenerateConfig from "rc-picker/lib/generate/moment";

export const DatePicker =
  AntDatePicker.generatePicker<moment.Moment>(momentGenerateConfig);
